import { Component, Inject, OnDestroy, OnInit, } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReportsService, DepotService, AssetTypeClassification, CollectionContainerDto, CollectionsReportSortColumn, CollectionsReportSortType} from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable } from 'rxjs';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
    selector: 'app-customer-collections-component',
    templateUrl: './customer-collections.component.html',
    styleUrls: ['./customer-collections.component.scss'],
    standalone: false
})
export class CustomerCollectionsComponent extends PagebaseComponent implements OnDestroy, OnInit {
  // Private variables
  customerId: string;
  data: CollectionContainerDto[];
  depotList: DropDownListItem[];
  userList: DropDownListItem[];
  hasMultipleDepots: boolean = false;
  selectedVehicleType: string;
  selectedFromDate = new UntypedFormControl(this.getDefaultFromDate());
  selectedToDate = new UntypedFormControl(this.getDefaultToDate());
  selectedDepotId: string;
  selectedUserId: string;
  assetTypeSearchControl: UntypedFormControl = new UntypedFormControl();
  sortColumn: string = CollectionsReportSortColumn[CollectionsReportSortColumn.ActionDate];
  sortDirection: string = CollectionsReportSortType[CollectionsReportSortType.Ascending];

  private apiCall;

  // Public variables
  loading: boolean = true;
  isAdmin: boolean = false;

  // Constuctor
  constructor(
    private _depotService: DepotService,
    private _reportsService: ReportsService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Collections");
  }

  ngOnInit() {
      this.authService.isAdmin().then(result => {
        this.isAdmin = result;
      })
  }

  ngOnDestroy() {
    this.unsubscribe()
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }  
  }

  getDefaultFromDate() {
    var d = new Date();

    d.setDate(d.getDate() - (d.getDay() + 6) % 7);
    d.setDate(d.getDate() - 7);

    return d;
  }

  getDefaultToDate() {
    var d = new Date();

    d.setDate(d.getDate() - (d.getDay() + 6) % 7);

    return d;
  }

  // Get the view data
  getData() {
    this.data = null;

    let selectedDepotId = this.sessionStorageService.getItem("customer-collections-selectedDepotId");
    if(selectedDepotId) {
      this.selectedDepotId = selectedDepotId;
    }
    else {
      this.selectedDepotId = null;
    }
    let selectedUserId = this.sessionStorageService.getItem("customer-collections-selectedUserId");
    if(selectedUserId) {
      this.selectedUserId = selectedUserId;
    }
    else {
      this.selectedUserId = null;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }
    let selectedFromDate = this.localStorageService.getItem("customer-collections-selectedFromDate");
    if(selectedFromDate) {
      selectedFromDate = JSON.parse(selectedFromDate);
      this.selectedFromDate = new UntypedFormControl(selectedFromDate);
    }
    let selectedToDate = this.localStorageService.getItem("customer-collections-selectedToDate");
    if(selectedToDate) {
      selectedToDate = JSON.parse(selectedToDate);
      this.selectedToDate = new UntypedFormControl(selectedToDate);
    }

    if(this.customerId != this.pageHelperService.selectedCompanyId) {
      this.customerId = this.pageHelperService.selectedCompanyId
      this._depotService.getUserDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const depotList: DropDownListItem[] = [];
        data.forEach(depot => {
          let depotItem = new DropDownListItem()
          depotItem.id = depot.id;
          depotItem.name = depot.name;
          depotList.push(depotItem)
        });
        
        this.hasMultipleDepots = depotList.length > 1;
        this.depotList = depotList;
      });

      this._reportsService.getCollectionUsers(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const userList: DropDownListItem[] = [];
        data.forEach(user => {
          let userItem = new DropDownListItem()
          userItem.id = user.userId;
          userItem.name = user.userNameDisplay;
          userList.push(userItem)
        });
        
        this.userList = userList;
      });
    }

    console.log("loading data");
    this.loading = true;
    this.setIsLoading(this.loading);
    
    this.apiCall = this._reportsService
      .getCollectionContainers(
        this.customerId,
        this.getDepotId(selectedDepotId),
        this.getUserId(selectedUserId),
        this.getFromDate(selectedFromDate),
        this.getToDate(selectedToDate),
        this.getSortColumn(this.sortColumn),
        this.getSortType(this.sortDirection))
      .subscribe(data => {
        this.data = data;
        this.loading = false;
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
  }

  getAssetTypeClassification(selectedVehicleType: string) {
    return !selectedVehicleType ? AssetTypeClassification.All : VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType)
  }

  getDepotId(selectedDepotId) {
    if (!selectedDepotId) {
      return null;
    }

    return selectedDepotId;
  }

  getUserId(selectedUserId) {
    if (!selectedUserId) {
      return null;
    }

    return selectedUserId;
  }

  getFromDate(selectedFromDate: string) {
    if (!selectedFromDate) {
        return moment(this.getDefaultFromDate());
    }

    return moment(selectedFromDate);
  }

  fromDateFilterChanged(newValue) {
    if (newValue) {
      this.localStorageService.setItem("customer-collections-selectedFromDate", JSON.stringify(newValue));
    }
    else {
      this.localStorageService.removeItem("customer-collections-selectedFromDate");
    }

    this.getData();
  }

  getToDate(selectedToDate: string) {
    if (!selectedToDate) {
        return moment(this.getDefaultToDate());
    }

    return moment(selectedToDate);
  }

  toDateFilterChanged(newValue) {
    if (newValue) {
      this.localStorageService.setItem("customer-collections-selectedToDate", JSON.stringify(newValue));
    }
    else {
      this.localStorageService.removeItem("customer-collections-selectedToDate");
    }

    this.getData();
  }

  depotChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("customer-collections-selectedDepotId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("customer-collections-selectedDepotId")
    }

    this.getData();
  }

  userChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("customer-collections-selectedUserId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("customer-collections-selectedUserId")
    }

    this.getData();
  }

  getSortColumn(sortColumn: string) {
    if (!sortColumn) {
      return CollectionsReportSortColumn.None;
    }

    if (sortColumn == CollectionsReportSortColumn[CollectionsReportSortColumn.Contract]) {
      return CollectionsReportSortColumn.Contract;
    }

    if (sortColumn == CollectionsReportSortColumn[CollectionsReportSortColumn.Container]) {
      return CollectionsReportSortColumn.Container;
    }

    return CollectionsReportSortColumn.ActionDate;
  }

  getSortType(sortDirection: string) {
    if (!sortDirection) {
      return CollectionsReportSortType.None;
    }

    if (sortDirection == CollectionsReportSortType[CollectionsReportSortType.Ascending]) {
      return CollectionsReportSortType.Ascending;
    }

    return CollectionsReportSortType.Descending;
  }

  sortData(columnName) {
    if (this.sortColumn == columnName) {
      this.sortDirection = this.sortDirection == CollectionsReportSortType[CollectionsReportSortType.Descending]
        ? CollectionsReportSortType[CollectionsReportSortType.Ascending]
        : CollectionsReportSortType[CollectionsReportSortType.Descending];
    }
    else {
      this.sortDirection = CollectionsReportSortType[CollectionsReportSortType.Ascending]
    }

    this.sortColumn = columnName;
    this.getData()
  }

  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    }
    else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType");
    }

    this.getData();    
  }
}
